'use strict';

Object.defineProperty(exports, "__esModule", { value: true });
exports.SessionChange = void 0;
var vue_class_component_1 = require("vue-class-component");
var functions_1 = require("./functions");
var magic_sdk_1 = require("@gig/magic-sdk");
/**
 * Decorator to react to session change events and automatically
 * unsubscribe after the component has been destroyed
 *
 * Decorated method will be called with the current logged in status.
 */
var SessionChange = function (_a) {
    var _b = _a === void 0 ? {} : _a, immediate = _b.immediate;
    return vue_class_component_1.createDecorator(function (options, key) {
        if (!options.methods) {
            options.methods = {};
        }
        var functionToCall = options.methods[key];
        if (functionToCall && typeof functionToCall === 'function') {
            var subscriptions_1 = [];
            options.created = functions_1.hookFunction(options.created, function () {
                var _this = this;
                var handler = function (isLoggedIn) {
                    functionToCall.call(_this, isLoggedIn);
                };
                if (immediate) {
                    handler(!!magic_sdk_1.magic.session.getUser());
                }
                subscriptions_1.push(magic_sdk_1.magic.events.sessionCreated(function () { return handler(true); }).unsub);
                subscriptions_1.push(magic_sdk_1.magic.events.sessionDestroyed(function () { return handler(false); }).unsub);
            });
            options.beforeDestroy = functions_1.hookFunction(options.beforeDestroy, function () {
                subscriptions_1.forEach(function (unsub) {
                    unsub();
                });
            });
        }
    });
};
exports.SessionChange = SessionChange;
